import { combineReducers } from "redux";

import {
    RECEIVE_UTU_SUSPECTS,
    SELECT_UTU_SUSPECT,
    SELECT_UTU_SUSPECT_SESSION,
    SET_UTU_SUSPECT_SEARCH_QUERY_FILTER,
    EXIT_CURRENT_DASHBOARD,
    SET_UTU_SUSPECT_DATE_FILTER,
    SET_TOTAL_UTU_COUNT,
    SET_UTU_FULLY_LOADED,
} from "redux/actions";

const INITIAL_SELECTED_SUSPECT_STATE = { uid: null, sessionID: null, loadedUID: null };

function data(state = [], action) {
    if (action.type === RECEIVE_UTU_SUSPECTS) {
        if (action.clear) {
            state = action.utu_suspects;
        } else {
            state = [...action.utu_suspects, ...state];
        }
    }
    return state;
}

function selectedSuspect(state = INITIAL_SELECTED_SUSPECT_STATE, action) {
    if (action.type === SELECT_UTU_SUSPECT) {
        state = { ...state, uid: action.uid };
    }
    if (action.type === SELECT_UTU_SUSPECT_SESSION) {
        state = { ...state, sessionID: action.sessionID, loadedUID: action.loadedUID };
    }

    if (action.type === EXIT_CURRENT_DASHBOARD) {
        state = INITIAL_SELECTED_SUSPECT_STATE;
    }
    return state;
}

function searchQueryFilter(state = "", action) {
    if (action.type === SET_UTU_SUSPECT_SEARCH_QUERY_FILTER) {
        state = action.searchQuery;
    }
    return state;
}

function dateFilter(state = { from: null, to: null }, action) {
    if (action.type === SET_UTU_SUSPECT_DATE_FILTER) {
        state = action.dates;
    }
    return state;
}

function count(state = 0, action) {
    if (action.type === SET_TOTAL_UTU_COUNT) {
        state = action.count;
    }
    return state;
}

function fullyLoaded(state = false, action) {
    if (action.type === SET_UTU_FULLY_LOADED) {
        state = action.fullyLoaded;
    }
    return state;
}

const utuSuspects = combineReducers({
    data,
    count,
    selectedSuspect,
    searchQueryFilter,
    dateFilter,
    fullyLoaded,
});

export default utuSuspects;
